export const getResponsiveColumns = (width) => {
  if (width >= 1600) return 4;
  if (width >= 1200) return 3;
  if (width >= 650) return 2;
  return 1;
};
